import React, { useState } from 'react';
import { IPavement } from '../../../../../../store/ducks/fabrication-mockups/types';
import { PavementsContainer, ButtonFaceliftContainer } from './styles';
import PavementItem from './PavementItem';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';

interface IPavementsProps {
  cleanNewestAddedPavementId: () => void;
  isSaving: boolean;
  mockupId: number;
  contractNumber: string;
  newestAddedPavementId?: string;
  onAddPavement: () => void;
  onRemovePavement: (pavementIdx: number) => void;
  onSavePavement: (pavement: IPavement) => void;
  pavements: IPavement[];
}

const Pavements: React.FC<IPavementsProps> = ({
  cleanNewestAddedPavementId,
  isSaving,
  mockupId,
  pavements,
  contractNumber,
  newestAddedPavementId,
  onAddPavement,
  onRemovePavement,
  onSavePavement
}) => {
  const [editingPavementIdx, setEditingPavementIdx] = useState<
    number | undefined
  >();
  const onChangePosition = (editedPavement: IPavement, newPosition: number) => {
    const pavement = pavements.find((p) => p.position === newPosition);
    if (pavement) {
      onSavePavement({
        ...pavement,
        position: editedPavement.position
      });
    }
    onSavePavement({
      ...editedPavement,
      position: newPosition
    });
  };

  const onEditClick = (pavementIdx?: number) => {
    setEditingPavementIdx(pavementIdx);
  };

  return (
    <>
      <PavementsContainer>
        {pavements?.map((pavement, idx) => (
          <PavementItem
            key={idx}
            index={idx}
            mockupId={mockupId}
            isSaving={isSaving}
            pavement={pavement}
            contractNumber={contractNumber}
            listOfPavementNames={pavements
              .filter((p) => p.id !== pavement.id)
              .map((p) => p.name)}
            onEditClick={onEditClick}
            onSavePavement={(editedPavement) => {
              onEditClick();
              onSavePavement(editedPavement);
            }}
            onRemovePavement={() => onRemovePavement(idx)}
            editingIdx={editingPavementIdx}
            onChangePosition={(newPosition) =>
              onChangePosition(pavement, newPosition)
            }
            totalPavementsAboveGround={
              pavements.filter((p) => p.position >= 0).length
            }
            totalPavementsBelowGround={
              pavements.filter((p) => p.position < 0).length
            }
            newestAddedPavementId={newestAddedPavementId}
            cleanNewestAddedPavementId={cleanNewestAddedPavementId}
            abovePavementHasOrders={
              idx > 0 && !!pavements[idx - 1].orders?.length
            }
            belowPavementHasOrders={
              idx + 1 < pavements.length && !!pavements[idx + 1].orders?.length
            }
          />
        ))}
        <ButtonFaceliftContainer>
          <Button
            name="addPavementBottom"
            disabled={isSaving}
            onClick={onAddPavement}
            variant="secondary"
            icon={<Icon option="PlusCircle" />}
            iconPosition="right"
          >
            Adicionar pavimento
          </Button>
        </ButtonFaceliftContainer>
      </PavementsContainer>
    </>
  );
};

export default Pavements;
